import style from '@/features/cabinet/ui/cabinet-sidebar-component/index.module.scss'
import { Link, useLocation } from 'react-router-dom'
import Logo from '@/shared/ui/Logo'
import { setDialogs } from '@/store/sub_accounts'
import { LOGOUT_DIALOG } from '@/entities/cabinet'
import { Icon } from '@/shared/ui'
import classNames from 'classnames'
import { LogoutDialog, useTheme } from '@/features'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState, useAppDispatch } from '@/store'
import { useTranslations } from 'use-intl'

const ITEMS = [
    {
        title: 'main',
        url: '/admin',
        type: 'dashboard',
    },
    {
        title: 'history',
        url: '/admin/history',
        type: 'earnings',
    },
    {
        title: 'users',
        url: '/admin/users',
        type: 'users',
    },
    {
        title: 'pool_settings',
        url: '/admin/pool_settings',
        type: '',
    },
]

const GENERAL_ITEMS = [
    {
        title: 'main',
        url: '/admin',
        type: 'dashboard',
    },
    {
        title: 'history',
        url: '/admin/history',
        type: 'earnings',
    },
]

const BOTTOM_ITEMS = [
    {
        title: 'logout',
        url: '/cabinet/logout',
        type: 'logout',
    },
]

export function AdminSidebarComponent() {
    const dialogs = useSelector((state: RootState) => state.subAccount.dialogs)
    const adminStatus = useSelector(
        (state: RootState) => state.subAccount.currentAdminLevel
    )
    const { pathname } = useLocation()
    const i18n = useTranslations('cabinet.sidebar')
    const dispatch = useAppDispatch()

    return (
        <aside className={style.sidebar}>
            <div className={style.sidebar__icon}>
                <Link
                    to="/"
                    className="logo"
                    style={{
                        display: 'flex',
                        height: '140px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Logo
                        width={200}
                        dark={false}
                        style={{
                            objectFit: 'cover',
                            height: `auto`,
                            width: '100%',
                        }}
                    />
                </Link>
            </div>
            <div className={style.sidebar__content}>
                <div className={style.sidebar__content__wrapper}>
                    <div className={style.sidebar__content__navbar}>
                        {(adminStatus.admin_level === 'ADMIN'
                            ? ITEMS
                            : GENERAL_ITEMS
                        ).map((item, idx) => (
                            <Link
                                to={item.url}
                                key={idx}
                                className={
                                    item.url === pathname ? style.active : ''
                                }
                            >
                                <Icon type={item.type as any} color={''} />
                                <span>{i18n(item.title)}</span>
                            </Link>
                        ))}
                    </div>
                    <div
                        className={classNames(
                            style.sidebar__content__bottomBar,
                            style.sidebar__content__navbar
                        )}
                    >
                        {BOTTOM_ITEMS.map((item, idx) => (
                            <Link
                                to={item.url}
                                key={idx}
                                onClick={(e) => {
                                    if (item.type === 'logout') {
                                        e.preventDefault()
                                        dispatch(
                                            setDialogs({
                                                key: LOGOUT_DIALOG,
                                                value: true,
                                            })
                                        )
                                    }
                                }}
                                className={
                                    item.url === pathname ? style.active : ''
                                }
                            >
                                <Icon type={item.type as any} />
                                <span>{i18n(item.title)}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            {dialogs[LOGOUT_DIALOG] && <LogoutDialog />}
        </aside>
    )
}
